import React from 'react'
import { Modal } from 'react-bootstrap';
import { FaSpinner } from 'react-icons/fa6';

const AmountLimitModel = ({ show, handleClose, amountLimit, setAmountLimit, loader, handleSubmit }) => {
    const handleChange = (e) => {
        const { name, value } = e.target;
        setAmountLimit({ ...amountLimit, [name]: value })
    }
    return (
        <Modal className="theme-modal table" show={show} onHide={handleClose} backdrop="static" centered>

            <Modal.Header closeButton style={{ borderBottom: "0", position: "absolute", top: "23px", right: "25px", zIndex: "20" }}>
            </Modal.Header>
            <Modal.Body className='mt-4 pt-4'>
                <h5 className='text-center mb-3'>Add Amount Limit</h5>
                <div className='creator_new_task h-100'>
                    {/* <form onSubmit={handleSubmit}> */}
                    <div className='account-block phone-emails mb-2'>

                        <div className='submission_wrap submission_bg mt-3 mb-3'>
                            <label className="form-label">Amount</label>
                            <input type="number"
                                className="form-control border-0"
                                placeholder="Enter amount" name="amount"
                                value={amountLimit.amount} onChange={handleChange}
                                onKeyDown={(e) => {
                                    if (!/^\d$/.test(e.key) && e.key !== 'Backspace' && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') {
                                        e.preventDefault();
                                    }
                                }}
                            />
                        </div>

                        <div className='d-flex justify-content-end gap-2 mt-4'>
                            <button className='theme-btn' type="button" onClick={handleClose}>Cancel</button>
                            <button className='theme-btn' type="button" onClick={handleSubmit}>{loader.save ? <>Updating<FaSpinner className='spin ms-1' style={{ fontSize: "13px" }} /> </> : "Save"}</button>
                        </div>
                    </div>
                    {/* </form> */}
                </div>
            </Modal.Body>
        </Modal >
    )
}

export default AmountLimitModel